<button
  mat-fab
  color="primary"
  class="fab fab-fixed-right"
  (click)="addActivity()"
  *ngIf="!itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
>
  <mat-icon>add</mat-icon>
</button>

<app-empty-list-message
  *ngIf="day.activities.length == 0"
  message="Per questo giorno non è ancora stata inserita alcuna attività."
  actionIcon="add"
  actionLabel="Aggiungi un'attività"
  (actionClick)="addActivity()"
  [disabled]="itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
>
  <div
    style="
max-width: 600px;
margin-left: auto;
margin-right: auto;
"
  >
    <p>
      <small
        >Tutti i punti di interesse (piazze, chiese, musei, punti panoramici,
        attività, escursioni, ristoranti, ecc) che farai visitare al cliente
        devono avere una card dedicata. non creare card generiche tipo “Centro
        di Praga” ma una card per ogni luogo da visitare nel centro di
        Praga.</small
      >
    </p>
    <p>
      <small
        >Devi sempre inserire una card di spostamento (piedi, bus, tram,
        bici...) da un luogo di interesse all’altro con indicazione del tempo di
        percorrenza nel campo “durata”. Anche dall’aeroporto quando il cliente
        arriva e per l’aeroporto quando riparte e all’inizio di ogni giornata
        dall’alloggio (preferito) al primo punto di interesse.<br />Se due punti
        di interesse si trovano ad 1-10 minuti di distanza a piedi, non importa
        la card spostamento, puoi inserire le due card dei punti di interesse
        accanto.</small
      >
    </p>
    <p>
      <small
        >Specificare sempre quando c’è un cambio di alloggio con una card
        “alloggio” per il check-in.</small
      >
    </p>
  </div>
</app-empty-list-message>

<mat-accordion>
  <mat-expansion-panel
    *ngFor="let activity of sortActivities(day.activities); index as activityId"
    [(expanded)]="expanded[activityId]"
  >
    <mat-expansion-panel-header>
      <mat-panel-title fxLayoutAlign="start center">
        <mat-icon class="header-icon">
          {{ getActivityTypeIcon(activity).icon }}
        </mat-icon>
        <span class="header-title" fxFlex
          >{{ activity.time?.toDate() | date: "HH:mm" }} &mdash;
          {{ activity.title }}</span
        >
        <div class="header-actions">
          <button
            mat-icon-button
            matTooltip="Rimuovi questa attività"
            (click)="removeActivity($event, activity)"
            *ngIf="
              !itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)
            "
          >
            <mat-icon aria-label="Rimuovi">delete</mat-icon>
          </button>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <app-itinerary-day-activity-form
      [activity]="activity"
      [activityId]="activityId"
      [itinerary]="itinerary"
      [disabled]="itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
    ></app-itinerary-day-activity-form>
  </mat-expansion-panel>
</mat-accordion>
